import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { INotificationTemplate } from 'app/shared/model/notification-template.model';
import { getEntities as getNotificationTemplates } from 'app/entities/notification-template/notification-template.reducer';
import { getEntity, updateEntity, createEntity, reset } from './notification-record.reducer';
import { INotificationRecord } from 'app/shared/model/notification-record.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const NotificationRecordUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const notificationTemplates = useAppSelector(state => state.notificationTemplate.entities);
  const notificationRecordEntity = useAppSelector(state => state.notificationRecord.entity);
  const loading = useAppSelector(state => state.notificationRecord.loading);
  const updating = useAppSelector(state => state.notificationRecord.updating);
  const updateSuccess = useAppSelector(state => state.notificationRecord.updateSuccess);
  const handleClose = () => {
    props.history.push('/notification-record' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getNotificationTemplates({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...notificationRecordEntity,
      ...values,
      notificationTemplate: notificationTemplates.find(it => it.id.toString() === values.notificationTemplate.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...notificationRecordEntity,
          notificationTemplate: notificationRecordEntity?.notificationTemplate?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="comexApp.notificationRecord.home.createOrEditLabel" data-cy="NotificationRecordCreateUpdateHeading">
            <Translate contentKey="comexApp.notificationRecord.home.createOrEditLabel">Create or edit a NotificationRecord</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="notification-record-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('comexApp.notificationRecord.message')}
                id="notification-record-message"
                name="message"
                data-cy="message"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.notificationRecord.status')}
                id="notification-record-status"
                name="status"
                data-cy="status"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.notificationRecord.customerID')}
                id="notification-record-customerID"
                name="customerID"
                data-cy="customerID"
                type="text"
              />
              <ValidatedField
                label={translate('comexApp.notificationRecord.userID')}
                id="notification-record-userID"
                name="userID"
                data-cy="userID"
                type="text"
              />
              <ValidatedField
                label={translate('comexApp.notificationRecord.quotationId')}
                id="notification-record-quotationId"
                name="quotationId"
                data-cy="quotationId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="notification-record-notificationTemplate"
                name="notificationTemplate"
                data-cy="notificationTemplate"
                label={translate('comexApp.notificationRecord.notificationTemplate')}
                type="select"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              >
                <option value="" key="0" />
                {notificationTemplates
                  ? notificationTemplates.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.type}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/notification-record" replace>
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default NotificationRecordUpdate;
